import { ComponentTypes } from '../Common/Components/types';
import { SignInSource } from '../constants';
import { DocumentStates, WorkflowTypes } from '../data/rsTypes';
import {
	EditedSignatureRequestSentEvent,
	SelfSignedTrackEvent,
	SignatureRequestSentTrackEvent,
} from './events';
export const getTrackingEventName = (document, documentTransaction) => {
	switch (true) {
		case document?.documentState === DocumentStates.Editing:
			return EditedSignatureRequestSentEvent;
		case documentTransaction.workflow === WorkflowTypes.SelfSign:
			return SelfSignedTrackEvent;
		default:
			return SignatureRequestSentTrackEvent;
	}
};
const allComponents = {
	SignatureAnnotationComponent: 'Yoursignature',
	CheckGroupComponent: 'Checkboxgroup',
	TextComponent: 'Text',
	DateComponent: 'Date',
	AttachmentComponent: 'Attachment',
	CheckComponent: 'Checkbox',
	SignatureComponent: 'Signature',
	CheckmarkAnnotationComponent: 'Addcheckmark',
	InitialsComponent: 'Initials',
	SelectComponent: 'Dropdown',
	TextAnnotationComponent: 'Addtext',
	PaymentComponent: 'Payment',
};
export const getFieldsDetails = components => {
	try {
		const counts = {};
		Object.entries(allComponents).forEach(([type, label]) => {
			if (type === ComponentTypes.DateComponent) {
				const dateSignedCount = components.filter(
					component =>
						component.type === ComponentTypes.DateComponent && component.is_date_signed
				).length;
				counts['DateSigned'] = dateSignedCount;
				const dateCount = components.filter(
					component =>
						component.type === ComponentTypes.DateComponent && !component.is_date_signed
				).length;
				counts[label] = dateCount;
			} else {
				counts[label] = components.filter(component => component.type === type).length;
			}
		});
		return counts;
	} catch (_error) {
		return {};
	}
};

export const getSignInSourceMetadata = (signInSource: string) => {
	const signInSourceMetadata = {
		clientMobileApp: signInSource === SignInSource.ClientMobileApp,
		clientPortal: signInSource === SignInSource.ClientPortal,
		employeePortal: signInSource === SignInSource.EmployeePortal,
		webApp: signInSource === SignInSource.WebApp,
	};
	return signInSourceMetadata;
};
